// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YwW1","left":"styles_left__2pMwC","right":"styles_right__1QW63","alert":"styles_alert__32S93"};